import { ThemeSwitchComponent } from "./ThemeSwitchComponent";
export default ThemeSwitchComponent;